import { code } from "@spscommerce/utils";

export const SpsCardExamples = {
  basic: {
    label: "Basic card",
    description:
      "<p>Basic Cards can include any type of content, such as tables, forms, description lists, or general copy</p>",
    examples: {
      basic: {
        template: code`
          <sps-card>
            <p>Plain card.</p>
          </sps-card>
        `
      },
      sections: {
        template: code`
          <sps-card>
            <section>
              <h3>Description</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
                ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
                voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat
                non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p>
            </section>
            <section>
              <h3>Usage Guidelines</h3>
              <p>
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque
                laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi
                architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione
                voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,
                consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et
                dolore magnam aliquam quaerat voluptatem.
              </p>
            </section>
          </sps-card>
        `
      },
      nestedSections: {
        template: code`
            <sps-card>
                <section>
                    <p>Card Header</p>
                </section>
                <section class="d-flex">
                    <section>
                        <p>Section 1</p>
                    </section>
                    <section>
                        <p>Section 2</p>
                    </section>
                    <section>
                        <p>Section 3</p>
                    </section>
                </section>
            </sps-card>
                `
      }
    }
  },
  headers: {
    label: "Card + Header",
    description: code`
      <p>Cards requiring a descriptive title or actionable items such as buttons
      or links can utilize the Card Header.</p>
    `,
    examples: {
      title: {
        template: code`
          <sps-card>
            <sps-card-header title="Card Title"></sps-card-header>
            <p>Card with title.</p>
          </sps-card>
        `
      },
      titleAndIcon: {
        description: code`
          <p>Icons can be used in conjunction with titles as visual indicators or decoration
          if desired.</p>
        `,
        template: code`
          <sps-card>
            <sps-card-header title="Card Title" icon="chart-pie">
            </sps-card-header>
            <p>Card with title and icon.</p>
          </sps-card>
        `
      },
      controls: {
        description: code`
          <p>Actions such as links or buttons can be included in a Card Header.</p>
          <ul>
            <li>Actions included in a Card Header should be relevant to the content
            displayed in the Card content below.</li>
            <li>Actions should be right aligned and follow the same styling rules as
            actions in the List Toolbar.</li>
          </ul>
        `,
        template: code`
          <sps-card>
            <sps-card-header title="Card Title">
              <sps-button-group>
                <sps-button kind="link">Button Text</sps-button>
                <sps-button kind="icon" icon="printer" aria-label="Print"></sps-button>
                <sps-button
                  kind="icon"
                  icon="download-cloud"
                  aria-label="Download"
                ></sps-button>
                <sps-button>Button</sps-button>
              </sps-button-group>
            </sps-card-header>
            <p>Card with controls in header.</p>
          </sps-card>
        `
      }
    }
  },
  footers: {
    label: "Card + Footer",
    description: "<p>Footer content could include buttons, links or basic text</p>",
    examples: {
      footerOnly: {
        description: code`
          <p>Basic text or links relevant to the Card content above it can be included in
          a footer. Footer text can be left, center, or right-aligned.</p>
        `,
        template: code`
          <sps-card>
            <p>Card with footer.</p>
            <sps-card-footer>Footer</sps-card-footer>
          </sps-card>
        `
      },
      controls: {
        description: code`
          <p>Actions such as links or buttons can be included in a Card Footer.</p>
          <ul>
            <li>Actions included in a Card Footer should be relevant to the content
            displayed in the Card content above.</li>
            <li>Actions should be right aligned and follow the same styling rules as
            actions in the List Toolbar.</li>
          </ul>
        `,
        template: code`
          <sps-card>
            <p>Card content</p>
            <sps-card-footer align="right">
              <sps-button-group>
                <sps-button kind="link">Button Text</sps-button>
                <sps-button kind="icon" icon="printer" aria-label="Print"></sps-button>
                <sps-button
                  kind="icon"
                  icon="download-cloud"
                  aria-label="Download"
                ></sps-button>
                <sps-button>Button</sps-button>
              </sps-button-group>
            </sps-card-footer>
          </sps-card>
        `
      },
      footerAndHeader: {
        template: code`
          <sps-card>
            <sps-card-header title="Card Title"></sps-card-header>
            <p>Card with header and footer.</p>
            <sps-card-footer>Footer</sps-card-footer>
          </sps-card>
        `
      }
    }
  },
  tabbed: {
    label: "Card + Tabs",
    description: code`
      <p>Multiple cards can be combined into a single view with the use of tabs.</p>
      <ul>
        <li>
          The content displayed in the Card below should be different for each tab
        </li>
        <li>
          The content in each tab should have a relationship or association to one
          another
        </li>
      </ul>
    `,
    examples: {
      tabsOnly: {
        template: code`
          <sps-card id="tabbedCardExample">
            <sps-card-tabbed-pane label="Tab 1">
              Card with tabs, pane 1.
            </sps-card-tabbed-pane>
            <sps-card-tabbed-pane label="Tab 2" icon="chart-area orange200">
              Card with tabs, pane 2.
            </sps-card-tabbed-pane>
            <sps-card-tabbed-pane label="Tab 3" tag="12">
              Card with tabs, pane 3.
            </sps-card-tabbed-pane>
          </sps-card>
        `
      },
      tabsAndHeader: {
        template: code`
          <sps-card>
            <sps-card-header title="Card Title"></sps-card-header>
            <sps-card-tabbed-pane label="Tab 1">
              Card with tabs and title, pane 1.
            </sps-card-tabbed-pane>
            <sps-card-tabbed-pane label="Tab 2">
              Card with tabs and title, pane 2.
            </sps-card-tabbed-pane>
            <sps-card-tabbed-pane label="Tab 3">
              Card with tabs and title, pane 3.
            </sps-card-tabbed-pane>
          </sps-card>
        `
      },
      tabsAndFooter: {
        template: code`
          <sps-card>
            <sps-card-tabbed-pane label="Tab 1">
              Card with tabs and footer, pane 1.
            </sps-card-tabbed-pane>
            <sps-card-tabbed-pane label="Tab 2">
              Card with tabs and footer, pane 2.
            </sps-card-tabbed-pane>
            <sps-card-tabbed-pane label="Tab 3">
              Card with tabs and footer, pane 3.
            </sps-card-tabbed-pane>
            <sps-card-footer>Footer</sps-card-footer>
          </sps-card>
        `
      },
      everything: {
        template: code`
          <sps-card>
            <sps-card-header title="Card Title"></sps-card-header>
            <sps-card-tabbed-pane label="Tab 1">
              Card with tabs, title, and footer, pane 1.
            </sps-card-tabbed-pane>
            <sps-card-tabbed-pane label="Tab 2">
              Card with tabs, title, and footer, pane 2.
            </sps-card-tabbed-pane>
            <sps-card-tabbed-pane label="Tab 3">
              Card with tabs, title, and footer, pane 3.
            </sps-card-tabbed-pane>
            <sps-card-footer>Footer</sps-card-footer>
          </sps-card>
        `
      },
      activeTabInput: {
        template: code`
          <sps-card activeTab="demo-tab-3">
            <sps-card-tabbed-pane id="demo-tab-1" label="Tab 1">
              activeTab input demo, pane 1.
            </sps-card-tabbed-pane>
            <sps-card-tabbed-pane id="demo-tab-2" label="Tab 2"
              icon="chart-area orange200"
            >
              activeTab input demo, pane 2.
            </sps-card-tabbed-pane>
            <sps-card-tabbed-pane id="demo-tab-3" label="Tab 3" tag="12">
              activeTab input demo, pane 3.
            </sps-card-tabbed-pane>
          </sps-card>
        `
      }
    }
  }
};
